import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g clipPath="url(#error-clip)">
      <circle cx={8} cy={7.999} r={5.714} fill="#fff" />
      <path
        fill="#DF4036"
        d="M7.991 0c4.413 0 7.991 3.511 7.991 7.843s-3.578 7.843-7.99 7.843C3.577 15.686 0 12.175 0 7.843S3.578 0 7.991 0Zm2.943 3.847L8 6.78 5.07 3.852 3.86 5.064l2.928 2.929-2.929 2.929 1.188 1.187L8 9.205l2.941 2.942 1.213-1.213-2.942-2.941 2.933-2.934-1.212-1.212h.001Z"
      />
    </g>
    <defs>
      <clipPath id="error-clip">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
